import { Component } from '@angular/core';

@Component({
  selector: 'app-en-tos-contents',
  templateUrl: './en-tos-contents.component.html',
})
export class EnglishTOSContentsComponent {}
